var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPower = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.12 16a.32.32 0 0 1-.303-.422L7.235 8.32H4.8c-.107 0-.206-.054-.266-.142s-.071-.25-.03-.348l3.2-7.68A.382.382 0 0 1 8 0h3.04a.32.32 0 0 1 .293.451L8.814 6.08H11.2a.32.32 0 0 1 .268.495l-6.08 9.28A.32.32 0 0 1 5.12 16z"
})));
export default SvgPower;